declare namespace $ {

	export class $bog_merchquarium_carousel extends $yuf_carousel {
	}
	
}

//# sourceMappingURL=carousel.view.tree.d.ts.map